import { algoliaSearch } from '@maison/search/algolia/AlgoliaSearch';
import algoliaInsights from '@module/Algolia/resources/js/search/AlgoliaInsights';
import AlgoliaData from '@module/Algolia/resources/js/search/interfaces/AlgoliaData';
import { InsightsTypes } from '@module/Algolia/resources/js/insights/types';

export const algoliaTracking = (
  item: AlgoliaData,
  position: number,
  index: string,
  eventName = 'search',
  type: InsightsTypes = 'click',
  // eslint-disable-next-line max-params
) => {
  if (!algoliaSearch.isAnalyticsEnabled()) {
    return;
  }

  if (!item.hasOwnProperty('_queryID') || !item.hasOwnProperty('_objectID')) {
    return;
  }

  algoliaInsights.handleClick(
    {
      objectIDs: [item._objectID],
      queryID: item._queryID,
      index,
      eventName,
      positions: [position + 1],
    },
    type,
  );
};
